import {lazy} from 'react'
import {Navigate, Route, Routes} from 'react-router-dom'

const DashboardAdministrative = lazy(() => import('../../pages/dashboard/DashboardAdministrative'))

export function DashboardRouter() {
    return (
        <Routes>
            <Route path='/dashboard/administrativo' element={<DashboardAdministrative />} />
            <Route path='/' element={<Navigate to='/dashboard/administrativo' replace />} />
        </Routes>
    )
}
